import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../lib/LanguageContext";

export default function Navbar() {
  const { lang, setLang, t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: "manifesto", label: t.nav.manifesto },
    { id: "services", label: t.nav.services },
    { id: "kits", label: t.nav.kits },
    { id: "hero-product", label: t.nav.hero },
    { id: "craft", label: t.nav.craft },
    { id: "corporate", label: t.nav.corporate },
  ];

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled ? "bg-paper/95 backdrop-blur-md border-b border-cream-300" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20 flex items-center justify-between py-5">
        <Link to="/" data-testid="nav-logo" className="inline-flex items-center text-ink hover:text-warmbrown transition-colors duration-500">
          <img src="/logo-amaranto.svg" alt="Amaranto" className="h-10 md:h-12 w-auto" />
          <span className="sr-only">Amaranto</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a key={l.id} href={`#${l.id}`} data-testid={`nav-link-${l.id}`}
              className="text-[11px] tracking-[0.3em] uppercase font-semibold text-ink hover:text-dustyrose-deep transition-colors duration-300">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-5">
          <div className="hidden sm:flex items-center text-[11px] tracking-[0.3em] uppercase font-semibold">
            <button data-testid="lang-toggle-es" onClick={() => setLang("es")}
              className={`px-1 transition-colors ${lang === "es" ? "text-warmbrown" : "text-ink-soft hover:text-ink"}`}>ES</button>
            <span className="text-cream-300 mx-1">/</span>
            <button data-testid="lang-toggle-en" onClick={() => setLang("en")}
              className={`px-1 transition-colors ${lang === "en" ? "text-warmbrown" : "text-ink-soft hover:text-ink"}`}>EN</button>
          </div>

          <a href="#kits" data-testid="nav-quote-cta"
            className="hidden md:inline-block text-[11px] tracking-[0.3em] uppercase font-semibold border border-ink px-5 py-3 text-ink hover:bg-ink hover:text-cream transition-all duration-500">
            {t.nav.quote}
          </a>

          <button data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} className="lg:hidden p-2 text-ink" aria-label="menu">
            <div className="w-6 h-px bg-ink mb-1.5" /><div className="w-6 h-px bg-ink mb-1.5" /><div className="w-4 h-px bg-ink" />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-paper border-t border-cream-300 px-6 py-8" data-testid="mobile-menu">
          <div className="flex flex-col gap-5">
            {links.map((l) => (
              <a key={l.id} href={`#${l.id}`} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${l.id}`}
                className="text-xs tracking-[0.3em] uppercase font-semibold text-ink">{l.label}</a>
            ))}
            <div className="flex gap-3 mt-3 text-xs tracking-[0.3em] uppercase font-semibold">
              <button data-testid="mobile-lang-es" onClick={() => setLang("es")} className={lang === "es" ? "text-warmbrown" : "text-ink-soft"}>ES</button>
              <span>/</span>
              <button data-testid="mobile-lang-en" onClick={() => setLang("en")} className={lang === "en" ? "text-warmbrown" : "text-ink-soft"}>EN</button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
